import React, { useState, useEffect } from 'react';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { api_getClientAdminDetail } from '../../../../api/apiAdmin';
import { RespClientAdminDetail } from '../../../../item/ItemAccount';
import { AdminCompanyList } from '../Company/CompanyList';
import { SingleText } from '../../Res/BaseInput';

export function ClientAdminDetail({id}) {
    const [accountId, setAccountId] = useState(id)
    const [mRespClientAdminDetail, setRespClientAdminDetail] = useState(new RespClientAdminDetail())

    useEffect(() => {
        if(id !== undefined && id !== accountId){
            setAccountId(id)
        }
    },[id])

    useEffect(()=>{
        console.log("api_getAdminDetail")
        api_getClientAdminDetail({
            accountId,
            success:(result)=>{
                var detail = new RespClientAdminDetail()
                detail.fromJson(result.detail)
                console.log(detail)
                setRespClientAdminDetail(detail)
            },
            failure:(err)=>{
                console.log(err)
            }
        })
    },[accountId])

    function toEdit(){
        window.location.assign("/ClientAdminEdit/"+accountId);
    }

    var title = '申請人資訊'
    var title_tools =
        <a className="dropdown-toggle " onClick={e=>toEdit()} data-toggle="dropdown" href="#A">
            <i class="fa fa-pencil text-warning"></i><span class="text-warning m-l-xs">編輯</span>
        </a>
    var content =
        <><div class="row">
            <div class="col-md-12">
                    <SingleText title={"啟用狀態"} val={mRespClientAdminDetail.isDisable===1?"停用中":"啟用中"} size={4} />
                    <SingleText title={"最近啟用日期"} val={"-"} size={4} />
                    <SingleText title={"最近停用日期"} val={"-"} size={4} />
            </div>
        </div>
            <div class="hr-line-dashed"></div>
            <div class="row">
                <div class="col-md-12">
                    <SingleText title={"帳號"} val={mRespClientAdminDetail.mobile} size={4} />
                    <SingleText title={"帳號"} val={mRespClientAdminDetail.nickName} size={4} />
                    <SingleText title={"電郵"} val={mRespClientAdminDetail.email} size={4} />
                </div>
            </div>
            <div class="hr-line-dashed"></div>
            <div class="row">
                <div class="col-md-12">
                    <SingleText title={"總公司數"} val={mRespClientAdminDetail.companyCount} size={4} />
                    <SingleText title={"啟用公司數"} val={mRespClientAdminDetail.companyEnableCount} size={4} />
                    <SingleText title={"停用公司數"} val={mRespClientAdminDetail.companyDisableCount} size={4} />
                </div>
            </div>
        </>
    return (
        <>
            <ContentBox title={title} title_tools={title_tools} content={content} hasDrawer={false} />
            <SystemPromptInput />
            <AdminCompanyList id={id} />
        </>
    )
}